"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectDependency = void 0;
const inversify_1 = require("inversify");
const common_1 = require("./common");
const INJECTION = Symbol.for('INJECTION');
function proxyGetter(proto, key, resolve, doCache) {
    function getter() {
        if (doCache && !Reflect.hasMetadata(INJECTION, this, key)) {
            Reflect.defineMetadata(INJECTION, resolve(this), this, key);
        }
        if (Reflect.hasMetadata(INJECTION, this, key)) {
            return Reflect.getMetadata(INJECTION, this, key);
        }
        return resolve(this);
    }
    function setter(newVal) {
        Reflect.defineMetadata(INJECTION, newVal, this, key);
    }
    Object.defineProperty(proto, key, {
        configurable: true,
        enumerable: true,
        get: getter,
        set: setter,
    });
}
function injectDependency(serviceIdentifier) {
    return function (proto, key) {
        const resolve = (componentInstance) => {
            var _a;
            if (!componentInstance.context) {
                throw new Error("Context doesn't exist on a target class. " +
                    'Please make sure to pass context object to super method if you access injectable stores in constructor.');
            }
            const metadata = Reflect.getMetadata(inversify_1.METADATA_KEY.TAGGED_PROP, proto.constructor) || {};
            if ((_a = metadata[key]) === null || _a === void 0 ? void 0 : _a.some(({ key, value }) => key === inversify_1.METADATA_KEY.OPTIONAL_TAG && value)) {
                if (componentInstance.context.isBound(serviceIdentifier)) {
                    return componentInstance.context.get(serviceIdentifier);
                }
            }
            else {
                return componentInstance.context.get(serviceIdentifier);
            }
        };
        if (proto.constructor.contextType && proto.constructor.contextType !== common_1.ContainerContext) {
            throw new Error("injectDependency can't be used together with contextType static property");
        }
        proto.constructor.contextType = common_1.ContainerContext;
        proxyGetter(proto, key, resolve, true);
    };
}
exports.injectDependency = injectDependency;
//# sourceMappingURL=inject-dependency.js.map